"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickFilterItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const QuickFilterItem = ({ quickLink }) => ((0, jsx_runtime_1.jsx)(cotopaxi_1.Button, { variant: cotopaxi_1.ButtonVariant.FILTER_ALT, shape: cotopaxi_1.ButtonShape.PILL, title: quickLink.linkName, href: `${quickLink.linkPath}${quickLink.queryStringParams || ''}`, text: quickLink.linkName }));
exports.QuickFilterItem = QuickFilterItem;
